import { ORDER_PAGE as dict } from '@/resources/dict'
import { deliveryTypeEnum } from '@/resources/enums/deliveryTypes'
import orderStatusEnum, {
  OrderExtraStatus,
} from '@/resources/enums/orderStatus'
import { parseUTCDate } from '@/resources/utils/global'

type StatusEventProperty = {
  key: string
  value: string
}

type StatusEvent = {
  event: StatusEventProperty[]
}

type ParsedStatusEvent = Record<string, string | Date | undefined> & {
  state: string | undefined
}

export const isPending = (status: string) => status === orderStatusEnum.PENDING

export const getStatusLabel = (status: string) =>
  (dict.statusLabel as Record<string, string | undefined>)[status]

export const getReasonLabel = (reason: string) =>
  (dict.reasonLabel as Record<string, string | undefined>)[reason]

const parseEventTimestampProp = ({ timestamp }: Record<string, string>) =>
  parseUTCDate(timestamp, 'HH:mm')

const parseEventStateProp = ({
  state,
  email,
}: Record<string, string | undefined>) => {
  let parsedStatus = (dict.eventState as Record<string, string | undefined>)[
    state ?? ''
  ]
  if (!email) parsedStatus = dict.eventState['NO_ANSWER_AND_EMAIL']
  return parsedStatus
}

const parseStatusEvent = (
  eventStatus: Record<string, string>
): ParsedStatusEvent => ({
  ...eventStatus,
  timestamp: parseEventTimestampProp(eventStatus),
  state: parseEventStateProp({ ...eventStatus }),
})

export const mapStatusEvents = (statusEvents?: StatusEvent[] | null) =>
  statusEvents
    ?.map(statusEvent => statusEvent?.event)
    ?.map(item => item.map(eventItem => eventItem))
    ?.map(events =>
      events.reduce<Record<string, string>>(
        (a, b) => ({ ...a, [b.key]: b.value }),
        {}
      )
    )
    ?.map(event => parseStatusEvent(event))

export const orderStatusExtraLabel = Object.freeze({
  [`${deliveryTypeEnum.RECEIVE},${orderStatusEnum.POC_ACCEPTED}`]:
    OrderExtraStatus.WAITING_COURIER,

  [`${deliveryTypeEnum.PICKUP},${orderStatusEnum.POC_ACCEPTED}`]:
    OrderExtraStatus.WAITING_CONSUMER,
})
